@if (loadingHandler | async) {
	<div class="overlay">
		<img src="./assets/spinner2.gif" />
	</div>
}

<h1 mat-dialog-title class="notification-title">{{ headingKey | translate }}</h1>

<mat-dialog-content style="overflow: hidden">
	<p class="mat-caption" [innerHTML]="subHeadingKey | translate" id="subHeadingKey"></p>

	<div class="optional-form-fields" style="margin: 16px 0">
		@for (field of optionalFields; track field) {
			@if (field['type'] !== 'checkbox') {
				<mat-form-field appearance="outline" class="dialog" [ngClass]="field['class'] ? field['class'] : ''">
					<mat-label>{{ field['titleKey'] | translate }}</mat-label>
					@if (formData[field.name] && !field.values && field['type'] !== 'checkbox') {
						<input
							matInput
							[name]="field.titleKey | translate"
							[placeholder]="field.titleKey | translate"
							[formControl]="formData[field.name]"
							[required]="field.mandatory === true"
							[type]="field['type'] ? field['type'] : 'text'"
							[min]="field.minimumValue !== false ? field.minimumValue : null"
							[readonly]="field['readonly']" />
					}
					@if (formData[field.name].invalid) {
						<mat-error>{{ field.errorMessage | translate }}</mat-error>
					}
					@if (field.values) {
						<mat-select [placeholder]="field.titleKey | translate" (selectionChange)="selectValueChange()" [formControl]="formData[field.name]">
							@for (val of field.values; track val) {
								<mat-option [value]="val">{{ val }}</mat-option>
							}
						</mat-select>
					}
				</mat-form-field>
			}
			@if (field['type'] === 'checkbox') {
				<mat-checkbox [formControl]="formData[field.name]">
					{{ field['titleKey'] | translate }}
				</mat-checkbox>
			}
		}
	</div>

	<div class="container" appDnd (fileDropped)="onFileDropped($event)">
		<input type="file" #fileDropRef id="fileDropRef" single (change)="fileBrowseHandler($event)" [accept]="allowedFileTypes.join(',')" />
		<!-- "accept" needs to be MIME types, i.e. 'image/png' or 'image/svg+xml' -->
		<mat-icon svgIcon="acies_upload"></mat-icon>
		<h3 class="mat-subtitle-2">{{ 'fileuploader.dragndrop' | translate }}</h3>
		<h3 class="mat-subtitle-2">{{ 'fileuploader.or' | translate }}</h3>
		<button mat-flat-button color="primary" cdkFocusInitial (click)="fileDropRef.click()" style="margin-top: 20px">
			{{ 'fileuploader.browsebtn' | translate }}
		</button>
	</div>

	@if (fileName) {
		<div class="fileAttachment mat-subtitle-2">
			<mat-icon svgIcon="acies_attachment" class="icon"></mat-icon>
			{{ fileName }}
			<mat-icon svgIcon="acies_delete" class="clickIcon" (click)="deleteFile()"></mat-icon>
		</div>
	}

	@if (illegalFileFormat) {
		<div class="illegalFile">{{ 'fileuploader.illegalformat' | translate }}: {{ illegalFileFormat }}</div>
	}

	@if (errorMessage) {
		<div class="illegalFile" [innerHTML]="errorMessage"></div>
	}
</mat-dialog-content>

<div>
	<div mat-dialog-actions align="end">
		<button mat-stroked-button (click)="onNoClick()" class="button-border-color">
			{{ 'fileuploader.cancelbtn' | translate }}
		</button>
		@if ((fileName || mode === 'edit') && checkRequiredFields()) {
			<button mat-flat-button color="primary" cdkFocusInitial (click)="processFile()">
				{{ confirmButtonKey | translate }}
			</button>
		}
	</div>
</div>
